export const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const escapeVcf = (value) => String(value ?? '')
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,');

// contacts: [{ name, phone }] -> vCard 3.0 metni
export const buildVcf = (contacts) => contacts
    .map(c => [
        'BEGIN:VCARD',
        'VERSION:3.0',
        `FN:${escapeVcf(c.name)}`,
        `N:${escapeVcf(c.name)};;;;`,
        `TEL;TYPE=CELL:${c.phone}`,
        'END:VCARD'
    ].join('\r\n'))
    .join('\r\n') + '\r\n';
